import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import ModalOverlay from "../../components/ModalOverlay";

import heroMobileImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_JulyUpdate_LP_767x577.jpg';
import heroDesktopImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_JulyUpdate_LP_1164x584.jpg';

import bodyDesktopImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_JulyUpdate_InfoGraphic_LP_927x521.jpg';
import bodyMobileImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_JulyUpdate_InfoGraphic_LP_728x409.jpg';

import { fireTag } from '../../libs/analytics.js';

const Propel = ({
    handleEvent,
    closeExitOverlay,
    addExitClickListeners,
    modalOverlay,
}) => {

    const [enableScrollGA, setEnableScrollGA] = useState(false);
    const [shouldBeInert, setShouldBeInert] = useState(false);
    const [gridVisible, setGridVisible] = useState(false);
    const heroOGImage = 'PO0131005_WF_BRAND_2HFY24_ISF_JulyUpdate_LP_ogimage.jpg';

    const toggleInert = () => {
        setShouldBeInert(!shouldBeInert)
    }

    const linkDisclosures = () => {
    
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {
		linkDisclosures();
		addExitClickListeners();
	}, []); // empty array says only use this effect once

    let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;

    let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			bodyImage = bodyMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
	}

    return (
		<>
			<Helmet>
				<title>Developing financial structures to propel clean energy</title>
				<meta
					name="description"
					content="Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund."
				/>
				<meta property="og:title" content="Building a pipeline of sustainable affordable housing"/>
				<meta
					property="og:description"
					content="Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Building a pipeline of sustainable affordable housing"/>
				<meta
					property="twitter:description"
					content="Wells Fargo Foundation funding is helping housing developers prepare to tap into the Greenhouse Gas Reduction Fund."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
                            Developing financial structures to propel clean energy
						</h1>
						<h2 className="summary">
                        Financial institutions can support Greenhouse Gas Reduction Fund recipients transitioning to a lower-carbon economy.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="Two workers in hard hats and safety goggles install a solar panel."/>
					</div>
				</div>


				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By Jeffrey Schub, <span>sustainable finance integration leader at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>July 15, 2024</p>
							</div>
							<div>
								<p>6-minute read</p>
							</div>
						</div>
						<p>
                        Private capital providers are ready to dive into one of the largest pools of
                        federal money earmarked for climate solutions. The <a onClick={()=> fireTag('A1','Greenhouse Gas Reduction Fund')} target="_blank" href="https://www.epa.gov/greenhouse-gas-reduction-fund/about-greenhouse-gas-reduction-fund" rel="noreferrer">Greenhouse Gas
                        Reduction Fund</a> (GGRF), a program within the Inflation Reduction Act, is set to
                        play a crucial role in shaping a sustainable, low-carbon future. It provides $27
                        billion in capital to fund activities that aim to reduce greenhouse gas (GHG)
                        emissions and air pollution; accelerate the deployment of climate and clean
                        energy technologies, particularly in underserved communities; and mobilize
                        financing and private capital.
						</p>
						<p>
                        GGRF consists of three programs: the National Clean Investment Fund (NCIF),
                        Clean Communities Investment Accelerator (CCIA), and Solar for All. The
                        majority of the funds — <a onClick={()=> fireTag('A1','20 billion in grants')} target="_blank" href="https://www.epa.gov/newsreleases/biden-harris-administration-announces-20-billion-grants-mobilize-private-capital-and" rel="noreferrer">$20 billion in grants</a> — is allocated through NCIF and
                        CCIA, which aims to provide accessible, affordable financing for clean
                        technology projects in partnership with the private sector. The remaining $7 billion is allocated to the <a onClick={()=> fireTag('A1','solar for all')} target="_blank" href="https://www.epa.gov/greenhouse-gas-reduction-fund/solar-all" rel="noreferrer">Solar for All</a> program, which
                        aims to create opportunities for households in low-income and disadvantaged communities to benefit from distributed solar energy.
						</p>
                        <p>
                        The NCIF and CCIA funds are designed to trickle down to clean energy and climate-related projects across the country from national
                        green banks, community development financial institutions, and a network of nonprofit clean energy-focused lending institutions.
                        However, large banks like Wells Fargo also have a key part to play. NCIF <a onClick={()=> fireTag('A1','funds must mobilize')} target="_blank" href="https://www.epa.gov/system/files/documents/2024-04/ggrf-charge-discussion-to-efab-capital-mobilization.pdf" rel="noreferrer">funds must mobilize</a> private co-investment into each qualified
                        project. That way, private capital can begin financing follow-on projects that otherwise would not be addressed. 
						</p>
                        <div className="flex-row article-image propel">
							<img alt={'A CGI rendering of a large modern building with solar panels in Baltimore'} src={bodyImage}/>
						</div>
						<h2 className="subhead" style={{marginTop: '1rem'}}>
                            Exploring the potential impact
						</h2>
						<p>
                        In April, the first $20 billion in grants through NCIF and CCIA were awarded to eight nonprofit entities. These awardees can use the
                        funding to directly invest in clean energy projects or to supply community lenders with capital and technical assistance to deploy these
                        projects in their local communities. More than 70% of the funding is expected to go to <a onClick={()=> fireTag('A1','low-income, disadvantaged, rural, and tribal communities')} target="_blank" href="https://www.epa.gov/environmentaljustice/inflation-reduction-act-disadvantaged-communities-map" rel="noreferrer">low-income, disadvantaged, rural, and tribal
                        communities</a>.
						</p>
					</div>
				</div>

                <div className="flex-row full-width">
					<div className="flex-row text-center">
						<div className="flex-col-md-8 flex-col-sm-12 text-center content-box">
							<div className="content-header bulleted">
								<h2 className="content-title bulleted">Objectives of the GGRF grant funds</h2>
							</div>
							<div className="inner-content bulleted">
								<div className="content">
									<div>
										<ul>
											<li className="offset-title">Finance clean energy and climate-related projects that reduce greenhouse emissions.</li>
											<li className="offset-title">Deliver positive economic impact with a particular focus on low-income and underserved communities.</li>
											<li className="offset-title">Mobilize private co-financing alongside the public funds.</li>
										</ul>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

                <div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center">
						<p>
                        The scope of projects eligible for GGRF funding is expansive. Winning nonprofit applicants must support <a onClick={()=> fireTag('A1','priority project categories')} target="_blank" href="https://www.epa.gov/system/files/documents/2024-04/ggrf-charge-discussion-to-efab-capital-mobilization.pdf" rel="noreferrer">priority project categories</a>,
                        such as net-zero buildings, zero-emissions transportation, or distributed energy generation and storage.
						</p>
						<h2 className="subhead">
                            Collaborating to unlock opportunities for private investments
						</h2>
                        <p>
                        While the government is providing $20 billion in the NCIF and CCIA programs, the awardees are expected to use those funds to leverage
                        more private capital to co-invest and participate in emissions-reducing projects. In fact, based on the applications and business plans
                        of the awardees, it is expected that each public dollar will <a onClick={()=> fireTag('A1','catalyze private finance')} target="_blank" href="https://www.epa.gov/newsreleases/biden-harris-administration-announces-20-billion-grants-mobilize-private-capital-and" rel="noreferrer">catalyze nearly $7 of private finance</a>. With that, the program is projected to
                        mobilize around $150 billion. 
						</p>
						<p>
						Wells Fargo hosted the first collaborative convening following the government’s announcement to help identify the range of support and infrastructure needed to mobilize GGRF capital. The bank and other private capital providers have a unique opportunity to finance projects, activities, and technologies. GGRF dollars are expected to absorb risk, take first losses, and otherwise participate in structures that will induce private lending and investment. Private capital gets the risk-adjusted returns it needs, and end customers realize economic benefits from clean energy — all possible because of GGRF capital.
						</p>
						<h2 className="subhead">
                            Supporting an equitable ecosystem
						</h2>
						<p>
                        The broad eligibility for GGRF funding helps to address a wide range of clean energy needs. The legislation requires that at least <a onClick={()=> fireTag('A1','40 percent of funds')} target="_blank" href="https://www.epa.gov/newsreleases/biden-harris-administration-announces-20-billion-grants-mobilize-private-capital-and" rel="noreferrer">40%
                        of the funds</a> are invested in low-income and disadvantaged communities. The applicants have all planned to target an even greater percentage of their investments to such communities. This means the GGRF is potentially the largest single federal investment in an equitable climate transition.
						</p>
                        <p>
                        Over the last year, Wells Fargo’s sustainability philanthropy prioritized GGRF-related funding. To help prepare awardees for the
                        inflow of capital, the Wells Fargo Foundation <a onClick={()=> fireTag('A1','provided grants')} target="_blank" href="https://welcome.wf.com/impact/sustainability/building-a-pipeline-of-sustainable-affordable-housing/" rel="noreferrer">provided grants</a> for technical assistance and capacity building, such as developing clean
                        energy finance products tailored to low- to moderate-income communities.
						</p>
                        <p>
                        GGRF presents a unique opportunity for climate-focused financial innovation, collaboration, and inclusion. By fostering public and
                        private sector partnerships, GGRF can help expand access to clean energy solutions and accelerate the transition toward a more
                        sustainable and equitable future.
						</p>
					</div>
				</div>
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
    );

};

export default withRouter(Propel);



